module.exports = __webpack_public_path__ + "img/36000.9ac459d4.jpg";